import type { InputHTMLAttributes } from 'react';
import { usarNumero, type OpcionLector } from './usarNumero';

/**
 * Campo numérico compacto para una fila o celda, sin etiqueta propia (el texto está al lado); para
 * formulario con etiqueta y ancho completo está `CampoNumero`. La alineación sigue al significado:
 * plata a la derecha, cantidad al centro; el relleno viaja con el tamaño.
 */
const TAMANOS = {
  corto: 'w-20 px-2 py-1', // cantidades de una o dos cifras, dentro de una celda
  medio: 'w-24 px-2 py-1', // cantidades con decimales
  largo: 'w-32 px-3 py-2', // dinero
  dinero: 'w-44 px-3 py-2', // plata que se escribe en una tabla ancha, donde la cifra se compara
  lleno: 'w-full px-3 py-2', // el ancho lo decide la celda o la columna que lo contiene
} as const;

export function NumeroEnLinea({
  ancho = 'medio',
  alineacion = 'derecha',
  className = '',
  valor,
  onValor,
  min,
  max,
  decimales,
  plata,
  lector,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'min' | 'max' | 'type'> & {
  ancho?: keyof typeof TAMANOS;
  alineacion?: 'derecha' | 'centro';
  valor: number | string | null | undefined;
  onValor: (n: number | null) => void;
  min?: number;
  max?: number;
  decimales?: boolean;
  /** Separador de miles en lo que se ve: solo para dinero. */
  plata?: boolean;
  lector?: OpcionLector;
}) {
  return (
    <input
      {...usarNumero({ valor, onValor, min, max, decimales, plata, lector })}
      className={`num rounded-control border-border border bg-card outline-none ${TAMANOS[ancho]} ${
        alineacion === 'derecha' ? 'text-right' : 'text-center'
      } ${className}`}
      {...props}
    />
  );
}
